import axios from 'axios';
import axiosInstance from './axiosInstance';
import { API_CONFIG, getUserUrl } from '../config/apiConfig';

export const loginUser = async (email: string, password: string) => {
  const response = await axios.post(getUserUrl(API_CONFIG.ENDPOINTS.USER.LOGIN), { email, password });
  return response.data;
};

export const signUpUser = async (user: any) => {
  const response = await axios.post(getUserUrl(API_CONFIG.ENDPOINTS.USER.SIGNUP), { user });
  return response.data;
};

export async function getUserDetails(userId: number) {
  const response = await axiosInstance.post(
    getUserUrl(API_CONFIG.ENDPOINTS.USER.GET_DETAILS),
    { userId }
  );
  return response.data;
}